"use client";
import React, { useMemo, useState } from "react";
import { useProductDetailsContext } from "@/src/provider";
import stl from "../../styles/productSizeSwiper.module.scss";
import classnames from "classnames";
import { FmButton } from "@/ui-component";
import SizeConversionCanvas from "../SizeConversionCanvas";
import { IProps } from ".";
import { useTranslation } from "@/src/i18n/client";

interface IClientProps extends IProps {}

const SizeSwiperClient: React.FC<React.PropsWithChildren<IClientProps>> = (
    props,
) => {
    const [productDetail, productImgList] = useProductDetailsContext(
        (state) => [state.productDetail, state.productImgList],
    );
    const { t } = useTranslation("productDetail");
    const [isInches, setIsInches] = useState(false);

    const handleChangeShowType = (isInches: boolean) => {
        setIsInches(isInches);
    };

    const imgSrc = useMemo(
        () => [
            {
                type: "Y" as const,
                src: productImgList[1],
                dimensions_bridge: productDetail.dimensions_bridge,
                dimensions_diagonal: productDetail.dimensions_diagonal,
                dimensions_height: productDetail.dimensions_height,
                dimensions_lens: productDetail.dimensions_lens,
                dimensions_temple: productDetail.dimensions_temple,
                dimensions_total_width: productDetail.dimensions_total_width,
            },
            {
                type: "X" as const,
                src: productImgList[2],
                dimensions_bridge: productDetail.dimensions_bridge,
                dimensions_diagonal: productDetail.dimensions_diagonal,
                dimensions_height: productDetail.dimensions_height,
                dimensions_lens: productDetail.dimensions_lens,
                dimensions_temple: productDetail.dimensions_temple,
                dimensions_total_width: productDetail.dimensions_total_width,
            },
        ],
        [
            productDetail.dimensions_bridge,
            productDetail.dimensions_diagonal,
            productDetail.dimensions_height,
            productDetail.dimensions_lens,
            productDetail.dimensions_temple,
            productDetail.dimensions_total_width,
            productImgList,
        ],
    );
    const sizeMemo = useMemo(() => {
        return imgSrc.map((item, index) => {
            return (
                <div key={index} className={stl["size-cover-container"]}>
                    <SizeConversionCanvas
                        canvasData={item}
                        onChangeShowType={handleChangeShowType}
                        isHideInchInCaontainer={true}
                        isInches={isInches}
                    />
                </div>
            );
        });
    }, [imgSrc, isInches]);

    const showToggleInchesButton = useMemo(() => {
        return isInches
            ? t("productDetail:ShowInMm")
            : t("productDetail:ShowInInches");
    }, [isInches, t]);
    return (
        <>
            <div
                className={classnames(
                    "default_layout",
                    stl["view-size-container"],
                )}
            >
                {!props.isHideTitle && (
                    <>
                        <p className={stl["product-details-size"]}>
                            {t(`productDetail:Size`) + ": "}
                            <span>
                                {`${productDetail.dimensions_lens}-${productDetail.dimensions_bridge}-${productDetail.dimensions_temple}`}
                            </span>
                        </p>
                        <FmButton
                            className={stl["canvas-inch"]}
                            onClick={() => handleChangeShowType(!isInches)}
                            variant={"text"}
                        >
                            {showToggleInchesButton}
                        </FmButton>
                    </>
                )}
            </div>
            {!props.isHideTitle ? (
                props.children
            ) : (
                <div
                    className={classnames(
                        "default_layout",
                        stl["view-size-container"],
                        {
                            [stl["show-bottom"]]: props.isHideTitle,
                        },
                    )}
                >
                    {props.children}
                    <FmButton
                        className={stl["canvas-inch"]}
                        onClick={() => handleChangeShowType(!isInches)}
                        variant={"text"}
                    >
                        {showToggleInchesButton}
                    </FmButton>
                </div>
            )}
            {sizeMemo}
        </>
    );
};

export default SizeSwiperClient;
